import KidStageItem from 'mk2/apps/blogs/components/KidStageItem';
import { KidEntity } from 'mk2/apps/settings/schemas';
import React from 'react';
import styles from './KidsStage.mscss';

interface OwnProps {
    isMobile: boolean;
    kids: KidEntity[];
}

type Props = OwnProps;

export default class KidsStage extends React.Component<Props> {

    public render() {
        const { isMobile, kids } = this.props;

        return (
            <div className={styles.KidsStage}>
                <div className={styles.KidsStage__kids}>
                    {kids.map((kid) => (
                        <div
                            className={styles.KidsStage__kid}
                            key={kid.id}
                        >
                            <KidStageItem
                                isMobile={isMobile}
                                kid={kid}
                            />
                        </div>
                    ))}
                </div>
                <div className={styles.KidsStage__stage}>
                    <div className={styles.KidsStage__stage__inner} />
                </div>
            </div>
        );
    }
}
